import { AssessmentOrder } from "../../../system/Domain";
import moment from "moment";
import TextGroup from "../../VehicleSales/TextGroup";
import TextLine from "../../VehicleSales/TextLine";

const MacadamAssessmentOrderTile = ({ order } : { order : AssessmentOrder }) => {
	return (
		<TextGroup>
			{order.dateTransferred
				? <TextLine label="Übertragen am" value={moment(order.dateTransferred).format("LLLL")} />
				: <TextLine label="Status" value="Übertragung steht noch aus" />}
		</TextGroup>
	)
};

export default MacadamAssessmentOrderTile;
